import { getSasUploadUrl, extractVideoThumbnail, uploadBlobToAzure, deleteTempBlob } from '../services/azureBlobService';

export async function executeAzureUploadFlow({
    file,
    prefix,
    thumbPrefix,
    shouldExtractThumbnail = true,
    onRegister,
    onProgress,
    onPhaseChange
}) {
    let uploadedBlobName = null;
    let uploadedThumbBlobName = null;

    try {
        if (onPhaseChange) onPhaseChange('preparing');

        const [sasResult, thumbnailBlob] = await Promise.all([
            getSasUploadUrl(file.name, prefix),
            shouldExtractThumbnail && thumbPrefix
                ? extractVideoThumbnail(file)
                : Promise.resolve(undefined)
        ]);

        if (thumbnailBlob && thumbPrefix) {
            const thumbFilename = `thumb_${file.name.replace(/\.[^.]+$/, '.jpg')}`;
            const thumbSasResult = await getSasUploadUrl(thumbFilename, thumbPrefix);
            await uploadBlobToAzure(thumbSasResult.sasUrl, thumbnailBlob);
            uploadedThumbBlobName = thumbSasResult.blobName;
        }

        if (onPhaseChange) onPhaseChange('uploading');
        await uploadBlobToAzure(sasResult.sasUrl, file, onProgress);
        uploadedBlobName = sasResult.blobName;

        if (onPhaseChange) onPhaseChange('saving');
        const registerResult = await onRegister({
            blobName: uploadedBlobName,
            thumbnailBlobName: uploadedThumbBlobName
        });

        return {
            blobName: uploadedBlobName,
            thumbnailBlobName: uploadedThumbBlobName,
            registerResult
        };
    } catch (err) {
        if (uploadedBlobName) deleteTempBlob(uploadedBlobName).catch(() => {
            console.warn('Failed to delete temporary blob', uploadedBlobName);
        });
        if (uploadedThumbBlobName) deleteTempBlob(uploadedThumbBlobName).catch(() => {
            console.warn('Failed to delete temporary thumbnail blob', uploadedThumbBlobName);
        });
        throw err;
    } finally {
        if (onPhaseChange) onPhaseChange(null);
    }
}
